import { render, staticRenderFns } from "./storedrule.vue?vue&type=template&id=4f99d378&scoped=true"
import script from "./storedrule.vue?vue&type=script&lang=js"
export * from "./storedrule.vue?vue&type=script&lang=js"
import style0 from "./storedrule.vue?vue&type=style&index=0&id=4f99d378&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f99d378",
  null
  
)

export default component.exports